export const initialFormData = {
  isAssignAnotherChecked: false,
  effectiveDate: null,
  contractSteward: null
}
